<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="column screen-width" style="gap: 20px; padding: 60px 0px">
            <p style="font-size: 32px; font-weight: bold">회원가입</p>
    
            <div style="width: 100%; height: 2px; background: black"></div>
            <div class="column align-center" style="gap: 40px; margin-top: 48px">
                <div class="row align-space-between" style="width:90%">
                    <div class="row">
                        <p style="font-size: 28px; font-weight: bold">
                            이름
                        </p>
                        <p style="font-size: 24px;
                                        color: gray;
                                        margin-left: 16px;
                                    ">
                            *
                        </p>
                    </div>
                    <input type="text" v-model="name" :disabled="userProfile" style="
                                    width: 60%;
                                    height: 56px;
                                    border-bottom: 1px solid #b4b4b4;
                                    padding: 12px;
                                " placeholder="이름을 입력해주세요." />
                </div>
                    <div class="row align-space-between"  style="width:90%">
                    <div class="row">
                        <p style="font-size: 28px; font-weight: bold">
                            이메일
                        </p>
                        <p style="font-size: 24px;
                                        color: gray;
                                        margin-left: 16px;
                                    ">
                            *
                        </p>
                    </div>
                    <input type="email" v-model="email" :disabled="userProfile" style="
                                    width: 60%;
                                    height: 56px;
                                    border-bottom: 1px solid #b4b4b4;
                                    padding: 12px;
                                " placeholder="이메일를 입력해주세요." />
                </div>
                
                <div class="row align-space-between" style="width:90%" >
                    <div class="row">
                        <p style="font-size: 28px; font-weight: bold">비밀번호</p>
                        <p style="
                                        font-size: 24px;
                                        color: gray;
                                        margin-left: 16px;
                                    ">
                            *
                        </p>
                    </div>
                    <input type="password" v-model="password" style="
                                    width: 60%;
                                    height: 56px;
                                    border-bottom: 1px solid #b4b4b4;
                                    padding: 12px;
                                " placeholder="6자리 이상의 비밀번호를 입력해주세요"  @input="validatePassword" />
                </div>
                <p v-if="passwordError" class="error-text">{{ passwordError }}</p>

                <div class="row align-space-between" style="width:90%" >
                    <div class="row">
                        <p style="font-size: 28px; font-weight: bold">비밀번호 확인</p>
                        <p style="
                                        font-size: 24px;
                                        color: gray;
                                        margin-left: 16px;
                                    ">
                            *
                        </p>
                    </div>
                    <input type="password" v-model="passwordCheck" style="
                                    width: 60%;
                                    height: 56px;
                                    border-bottom: 1px solid #b4b4b4;
                                    padding: 12px;
                                " placeholder="위 비밀번호를 다시 입력해주세요"  @input="checkPasswordMatch"/>
                </div>
                <p v-if="passwordCheckError" class="error-text">{{ passwordCheckError }}</p>

                <div class="row align-space-between" style="width:90%">
                    <div class="row">
                        <p style="font-size: 28px; font-weight: bold">연락처</p>
                        <p style="
                                        font-size: 24px;
                                        color: gray;
                                        margin-left: 16px;
                                    ">
                            *
                        </p>
                    </div>
                    <input type="text" v-model="phoneNumber" :disabled="userProfile" style="
                                    width: 60%;
                                    height: 56px;
                                    border-bottom: 1px solid #b4b4b4;
                                    padding: 12px;
                                " placeholder="'-'없이 휴대폰 번호를 입력해주세요"
                                @input="formatPhoneNumber" />
                </div>
                <div  style="width:90%">
                    <div class="row align-space-between">
                        <div class="row">
                            <p style="font-size: 28px; font-weight: bold">
                                주소
                            </p>
                        </div>
    
                        <div class="row align-space-between" style="width: 60%">
                            <input type="text" v-model="roadAddress" style="
                                            width: 80%;
                                            height: 56px;
                                            border-bottom: 1px solid #b4b4b4;
                                            padding: 12px;
                                        " placeholder="주소를 검색하여 선택해주세요" />
                            <button class="align-center" style="
                                            width: 12%;
                                            height: 56px;
                                            border: 1px solid black;
                                            border-radius: 25px;
                                            font-weight: bold;
                                        " @click="openPostCode">
                                        검색
                                    </button>
                        </div>
                    </div>
                    <div class="row" style="
                                    justify-content: end;
                                    align-items: center;
                                    margin-top: 20px;
                                ">
                        <input type="text" v-model="detailAddress" style="
                                        width: 60%;
                                        height: 56px;
                                        border-bottom: 1px solid #b4b4b4;
                                        padding: 12px;
                                    " placeholder="상세 주소를 입력해주세요" />
                    </div>
                </div>
            
                <div class="row align-space-between" style="width:90%">
                    <p style="font-size: 28px; font-weight: bold">
                        개인정보 수집 • 이용 동의
                    </p>
                    <div class="row align-space-between" style="width: 40%">
                        <div class="row" style="gap: 40px">
                            <input type="radio" v-model="isAgree" :value="true" style="width: 40px" />
                            <p style="font-size: 24px">동의</p>
                        </div>
                        <div class="row" style="gap: 40px">
                            <input type="radio" v-model="isAgree" :value="false" style="width: 40px" />
                            <p style="font-size: 24px">동의 안함</p>
                        </div>
                    </div>
                </div>
                <div
                    style="
                        width: 100%;
                        height: auto;
                        border-radius: 20px;
                        border: 1px solid #d9d9d9;
                        padding: 32px;
                    "
                >
                    <p>고객님의 원활한 서비스 신청, 상담, 이력관리 등을 위해 개인정보 수집 및 이용 동의를 받고 있습니다.</p>
                    <br>
                    <p><strong>수집 항목:</strong> 성명, 전화번호, 주소</p>
                    <br>
                    <p><strong>수집 · 이용 목적:</strong> 제품 A/S 및 B/S, 상담, 제품 교환/환불, 고객만족도 조사</p>
                    <br>
                    <p><strong>보유·이용 기간:</strong> 5년 (수정되는 정보 포함)</p>
                    <p>(단, 상법 등 타 법령에 따른 정보는 해당 법령에서 정한 기간 보존)</p>

                    <p>※ 귀하께서는 본 동의를 거절하실 수 있으나, 미동의 시 해당 서비스 신청 및 이용에 제약이 있을 수 있습니다.</p>

                    <p>※ 개인정보 처리에 대한 상세한 사항은 화면 하단의 개인정보 처리방침을 참조하십시오.</p>
                    <br>
                    <p><strong>개인정보 입력 시 주의사항</strong></p>
                    <p>- 개인정보 보호를 위해 본인 외 타인의 정보(가족 포함)는 입력이 불가합니다.</p>
                    <p>- 잘못된 정보 제공으로 인한 책임은 정보 제공자에게 있으니 주의해 주시기 바랍니다.</p>
                    <p>- 본 화면에 입력하신 개인정보는 실제 서비스(상담)나 상품 주문 등을 신청해야 수집이 되며, 그 외에는 수집 또는 저장되지 않습니다.</p>
                </div>

                <button
                    style="
                        width: 640px;
                        height: 100px;
                        background: #27afe2;
                        border-radius: 20px;
                        color: white;
                        font-size: 40px;
                        font-weight: bold;
                    "
                    @click="submitSignup"
                >
                    접수 완료
                </button>
            </div>

        </div>
    </v-container>
</template>

<script>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ref, computed } from "vue";

export default {
    components: {},
    setup() {
        const store = useStore();
        const router = useRouter();
        const name = ref("");
        const email = ref("");
        const password = ref("");
        const passwordCheck = ref("");
        const phoneNumber = ref("");
        const roadAddress = ref("");
        const detailAddress = ref("");
        const address = ref("");
        const isAgree = ref(false);
        // 에러 메시지
        const passwordError = ref("");
        const passwordCheckError = ref("");


        const submitSignup = async () => {
            if (!isAccess.value) {
                alert("입력되지 않거나 형식이 잘못된 정보가 있습니다.");
                return;
            }

            const userInfo = {
                name: name.value,
                email: email.value,
                password: password.value,
                address: roadAddress.value + ":" + detailAddress.value,
                phone_number: phoneNumber.value,
                agree: isAgree.value
            }

            store
                .dispatch("signup", userInfo)
                .then(() => {
                    alert("회원가입 성공하였습니다.");
                    router.replace({ path: "/login" }); // 로그인 성공 후 홈으로 리디렉션
                })
                .catch((error) => {
                    console.log(error);
                    alert("로그인을 실패하였습니다");
                });
            
        };

          // 비밀번호 유효성 검사
        const validatePassword = () => {
            if (password.value.length < 6) {
                passwordError.value = "비밀번호는 최소 6자리 이상이어야 합니다.";
            } else {
                passwordError.value = "";
            }
        };

        // 비밀번호 확인 검사
        const checkPasswordMatch = () => {
            if (password.value !== passwordCheck.value) {
                passwordCheckError.value = "비밀번호가 일치하지 않습니다.";
            } else {
                passwordCheckError.value = "";
            }
        };

        // 휴대폰 번호 형식 제한 (숫자만 입력 가능)
        const formatPhoneNumber = () => {
            phoneNumber.value = phoneNumber.value.replace(/[^0-9]/g, "").slice(0, 11);
        };

        // 모든 필드가 입력되었는지 확인
        const isAccess = computed(() => {
            return (
                name.value &&
                email.value &&
                password.value.length >= 6 &&
                password.value === passwordCheck.value &&
                phoneNumber.value.length >= 10 &&
                isAgree.value
            );
        });


        const openPostCode = () => {
            new window.daum.Postcode({
                oncomplete: (data) => {
                    roadAddress.value = data.roadAddress;
                },
            }).open();
        };


        return {
            submitSignup,
            name,
            email,
            password,
            passwordCheck,
            passwordError,
            passwordCheckError,
            phoneNumber,
            address,
            roadAddress,
            detailAddress,
            isAgree,
            isAccess,
            validatePassword,
            checkPasswordMatch,
            formatPhoneNumber,
            openPostCode
        };
    },
};
</script>

<style scoped>
.container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50%;
    min-width: 300px;
    min-height: 400px;
    position: relative;
    z-index: 1;
}

.container::after {
    content: "";
    width: 25%;
    height: 50%;
    min-width: 300px;
    min-height: 400px;
    position: absolute;
    /* background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0) ),
    url(@/assets/background_img.jpg); */
    background-repeat: no-repeat;
    background-size: cover;
    z-index: -1;
    opacity: 0.6;
}

.login-view {
    width: 100%;
    height: 500px;
    background: white;
    border: 2px solid rgba(0, 0, 0, 0.2);
    border-radius: 10px;
}

.logo-view {
    width: 100%;
    text-align: center;
    height: 45%;
}

.input-user {
    width: 600px;
    text-align: center;
    height: 240px;
}

.input-form {
    width: 600px;
    border: 1px solid black;
    height: 80px;
    margin: 10px;
    text-indent: 15px;
}

.button {
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: center;
}
.error-text {
    margin-left: calc(40% + 20px);
    margin-right:auto;
    color: red;
    font-size: 18px;
    margin-top: -10px;
}

</style>
